// 介錯「据えの一打」(exec_maulSet) の3連で、近すぎる時は前へ寄らない (2026-10-10)。
//   出所 = docs/research/2026-10-10-executioner-fresh-eyes.md の E1 (3発の当たりごとに介錯が踏み込み、中心の差が
//          101→61→52→49px と詰まって主人公が外套に埋まる・主人公が動かなくても起きる)。
//          作りと測った数字 = docs/research/2026-10-10-maulset-gap-status.md。
//   既定 = 新 (on・2026-10-10 ユーザー採用「新を採る」)・旧は DEV ?maulSetGap=0。
//
//   on の時、据えの一打の3段それぞれの踏み込みの着地を「主人公の手前の止まり幅」より内側へ入れない。
//     ・止まり幅 = 介錯の体の半幅 (bosses.ts bodyHalfWidthPx 50) + 主人公の半幅 (BOSS_CORE.playerHalfWidth 15) = 65px
//       = 体どうしが触れる所 (10-06 ユーザー「体どうしが食い込む重なりだけ直す」・E1 の重なりの数え方と同じ線)。
//     ・近すぎる時は踏み込み 0 = その場で振る (下がりはしない)。遠い時の踏み込み (追い・最大量) は今のまま。
//     ・当たりの範囲・時間・ダメージは変えない (段ごとの前端 135/89/117px + 主人公の半幅 15 > 65 なので3段とも届く)。
//   ほかの技の踏み込み (minLungeFrac を使う全部) には広げない。
//   DEV ?maulSetGap=<px> (40〜160) で止まり幅だけ替えて試せる。
import { BOSS_CORE } from './balance'
import { getBossDefinitionById } from './bosses'

const ATTACK_ID = 'exec_maulSet'
const BOSS_ID = 'the-executioner'

// ボス定義の初期化が終わってから、既定の止まり幅を解決する。
let stopPx: number | null | 'default' = 'default'

/** DEV の URL の値をそのまま渡す。'0' / 'off' = 旧・40〜160 の数 = その px・'1' / null / '' / それ以外 = 既定。 */
export function setMaulSetStop(v: string | null): void {
  if (v === '0' || v === 'off') { stopPx = null; return }
  const n = Number(v)
  stopPx = v !== null && v !== '' && Number.isFinite(n) && n >= 40 && n <= 160 ? n : 'default'
}
export function maulSetStopPx(): number | null { return stopPx === 'default' ? maulSetDefaultStopPx() : stopPx }

/** 既定の止まり幅 = 介錯の体の半幅 + 主人公の半幅 (体が触れる所)。 */
export function maulSetDefaultStopPx(): number {
  const half = getBossDefinitionById(BOSS_ID)?.bodyHalfWidthPx ?? 50
  return half + BOSS_CORE.playerHalfWidth
}

/** 据えの一打の踏み込みにだけ効く止まり幅。対象外・off なら undefined (= 今の決まりのまま)。 */
export function maulSetStopFor(boss: { id: string }, atk: { id: string }): number | undefined {
  if (boss.id !== BOSS_ID || atk.id !== ATTACK_ID) return undefined
  return maulSetStopPx() ?? undefined
}
